<template>
  <v-layout justify-center wrap>
    <div v-if="error">{{ error }}</div>
    <v-flex md12 v-if="!error">
      <material-card
        color="success"
        title="Membros"
        text="Membros cadastrados na plataforma"
      >
        <v-layout>
          <v-flex sm12 md4 text-xs-left>
            <v-select
              :items="status"
              label="Status"
              @change="filterStatus"
            ></v-select>
          </v-flex>
          <v-flex xs3>
            <v-menu
              ref="show_start_date"
              :close-on-content-click="false"
              v-model="show_start_date"
              :nudge-right="40"
              :return-value.sync="start_date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="start_date"
                label="From"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="start_date"
                @input="filterStartDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs3>
            <v-menu
              ref="show_end_date"
              :close-on-content-click="false"
              v-model="show_end_date"
              :nudge-right="40"
              :return-value.sync="end_date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="end_date"
                label="To"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="end_date"
                @input="filterEndDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm12 md8 text-xs-left>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
              @input="filterSearch"
            ></v-text-field>
          </v-flex>
          <v-flex sm12 md2 text-xs-right text-md-right>
            <v-btn
              class="mx-0 font-weight-light"
              color="primary"
              @click.prevent="newCustomer()"
            >
              <v-icon left dark>add</v-icon>Novo Cliente
            </v-btn>
          </v-flex>
          <v-flex sm12 md2 text-xs-right text-md-right>
            <v-btn
              class="mx-0 font-weight-light"
              color="secondary"
              @click.prevent="_export(users)"
            >
              <v-icon left>mdi-file-excel</v-icon>Exportar
            </v-btn>
          </v-flex>
        </v-layout>
        <v-progress-linear
          v-if="loading"
          height="2"
          v-slot:loading
          color="cyan"
          indeterminate
        ></v-progress-linear>
        <v-data-table
          dense
          :headers="headers"
          :items="users"
          :loading="loading"
          :search="filters"
          :custom-filter="customFilter"
          no-data-text="Não há membros cadastrados"
          rows-per-page-text="Linhas por página"
          :pagination.sync="pagination"
        >
          <template slot="headerCell" slot-scope="{ header }">
            <span
              class="subheading font-weight-light text-success text--darken-3"
              v-text="header.text"
            />
          </template>
          <template slot="items" slot-scope="{ item }">
            <td>{{ item.created_at | formatarData }}</td>
            <td>{{ item.updated_at | formatarData }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone || "" }}</td>
            <td>{{ item.status || "" }}</td>
            <td class="text-xs-right">
              <v-icon
                left
                v-if="
                  item.card_default &&
                  item.card_default !== '' &&
                  (item.payment_type === 'credit_card' ||
                    item.payment_type === 'credit-card')
                "
                >mdi-credit-card-plus</v-icon
              >
              <v-icon
                left
                v-else-if="item.payment_type && item.payment_type === 'boleto'"
                >mdi-barcode</v-icon
              >
              <v-icon
                left
                v-else-if="item.payment_type && item.payment_type === 'pix'"
                >qr_code_2</v-icon
              >
            </td>
            <td class="text-xs-right">
              <a
                :href="
                  encodeURI(
                    'https://web.whatsapp.com/send?phone=' +
                      formatWhatsappPhone(item.phone) +
                      '&text=Olá ' +
                      item.name.split(' ')[0] +
                      ', *seja bem-vindo(a) a Enercred!* ⚡ Parabéns por entrar para o mundo da economia e sustentabilidade. Meu nome é *Caio* e estou aqui para te ajudar.',
                  )
                "
                target="_blank"
              >
                <v-icon>mdi-whatsapp</v-icon>
              </a>
            </td>
            <!-- <td>{{ item.card_default }}</td> -->
            <td>
              <v-icon @click.prevent="customerSelected(item)"
                >visibility</v-icon
              >
            </td>
          </template>
          <v-alert v-slot:no-results :value="true" color="error" icon="warning"
            >Sua busca para "{{ search }}" não retornou resultados.</v-alert
          >
          <template v-slot:pageText="items"
            >Linhas {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}</template
          >
        </v-data-table>
      </material-card>
    </v-flex>
  </v-layout>
  <!-- </v-container> -->
</template>
<script>
import moment from "moment";
import { eventBus } from "../../main";
import XLSX from "xlsx";

export default {
  props: ["users", "error"],
  data: () => ({
    filters: {
      search: "",
      status: "",
      start_date: null,
      end_date: null,
    },
    show_start_date: false,
    start_date: null,
    show_end_date: false,
    end_date: null,
    search: "",
    loading: false,
    status: ["ATIVO", "DESQUALIFICAR", "INATIVO", "QUALIFICAR"],
    data: [
      [
        "indice",
        "nome",
        "email",
        "telefone",
        "data de criacao",
        "ultima atualizacao",
        "assinado em",
        "endereco",
        "Documento",
        "CPF",
        "ID do usuário",
        "Data de Nascimento",
        "Sexo",
        "Estado Civil",
        "Comunhao de Bens",
        "Status",
        "Profissao",
        "Saldo de Indicação",
        "Recebeu por indicações",
        "metodo de pagamento",
        "possui cartao?",
      ],
    ],
    headers: [
      {
        sortable: true,
        text: "Criado",
        value: "created_at",
      },
      {
        sortable: true,
        text: "Atualizado",
        value: "updated_at",
      },
      {
        sortable: true,
        text: "Name",
        value: "name",
      },
      {
        sortable: true,
        text: "E-mail",
        value: "email",
      },
      {
        sortable: true,
        text: "Telefone",
        value: "phone",
      },
      {
        sortable: true,
        text: "Status",
        value: "status",
      },
      {
        sortable: false,
        text: "Met. Pag.",
        value: "payment_type",
      },
      {
        sortable: false,
        text: "Whats",
        value: "whatsapp",
      },
      // {
      //     sortable: true,
      //     text: 'card_default',
      //     value: 'item.card_default',
      //     align: 'right'
      // },

      {
        text: "   ",
        sortable: false,
        name: "edit",
      },
    ],
    pagination: {
      sortBy: "item.item.updated_at",
      rowsPerPage: 10,
    },
  }),
  filters: {
    formatarData: function (value) {
      if (!value) return "-";
      let timestamp = value; // firebase data
      let myDate = new Date(); // date object
      // console.log(timestamp.valueOf().seconds)
      if (timestamp.valueOf().seconds) {
        // myDate = timestamp.toDate()
        myDate = new Date(timestamp.seconds * 1000); // date object
      } else if (timestamp.valueOf()._seconds) {
        myDate = new Date(timestamp._seconds * 1000); // date object
      } else {
        return "-";
      }
      return moment(myDate.toISOString()).format("DD/MM/YYYY");
    },
    formatDate: function (value) {
      if (!value) return "";
      if (typeof value === "string") {
        return moment(value).format("DD/MM/YYYY");
      }
      let timestamp = value; // firebase data
      let myDate = new Date(timestamp._seconds * 1000); // date object
      if (typeof myDate !== "object") {
        return "";
      }
      return moment(myDate.toISOString().substr(0, 10)).format("DD/MM/YYYY");
    },
  },
  methods: {
    customerSelected(customer) {
      this.loading = true;
      eventBus.$emit("userSelected", customer);
      this.$router.push({
        path: "/membro/" + customer.customer_id,
        params: { id: customer.customer_id },
      });
    },
    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);

      cf.registerFilter("search", function (searchWord, items) {
        if (searchWord.trim() === "") return items;

        return items.filter((item) => {
          return item.name.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });

      cf.registerFilter("status", function (status, items) {
        if (status.trim() === "") return items;

        return items.filter((item) => {
          if (item.status)
            return item.status.toLowerCase() === status.toLowerCase();
          else return false;
        }, status);
      });

      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "start_date" filter.
      cf.registerFilter("start_date", function (start_date, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (start_date === null) return items;
        // Compare each item start_date and just return the matching ones.
        return items.filter((item) => {
          let timestamp = item.created_at; // firebase data
          if (timestamp.valueOf().seconds)
            return timestamp.valueOf().senconds >= start_date;
          else if (timestamp.valueOf()._seconds)
            return timestamp.valueOf()._seconds >= start_date;
          else return false;
        }, start_date);
      });
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "end_date" filter.
      cf.registerFilter("end_date", function (end_date, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (end_date === null) return items;
        // Compare each item end_date and just return the matching ones.
        return items.filter((item) => {
          return item.created_at <= end_date;
        }, end_date);
      });

      // Its time to run all created filters.
      // Will be executed in the order thay were defined.
      return cf.runFilters();
    },

    /**
     * Handler when user input something at the "Filter" text field.
     */
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val,
      });
    },

    /**
     * Handler when user  select some author at the "Author" select.
     */
    filterStatus(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        status: val,
      });
    },

    /**
     * Handler when select a date on "From" date picker.
     */
    filterStartDate(val) {
      // Close the date picker.
      this.$refs.show_start_date.save(val);
      //Convert the value to a timestamp before saving it.
      const timestamp = new Date(val + "T00:00:00Z").getTime();
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        start_date: timestamp,
      });
    },
    /**
     * Handler when select a date on "To" date picker.
     */
    filterEndDate(val) {
      // Close the date picker.
      this.$refs.show_end_date.save(val);
      //Convert the value to a timestamp before saving it.
      const timestamp = new Date(val + "T00:00:00Z").getTime();
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        end_date: timestamp,
      });
    },

    async newCustomer() {
      this.$router.push({ path: "/membro/" });
    },
    async _export(users) {
      /* convert state to workbook */
      users.forEach((item, index) => {
        item.id = index;
        var address = "";
        if (item.address) {
          address = item.address.address;
          if (item.address.address_number) {
            address = address + ", " + item.address.address_number;
          }
          if (item.address.address_complement) {
            address = address + ", " + item.address.address_complement;
          }
          if (item.address.district) {
            address = address + " - " + item.address.district;
          }
          if (item.address.city) {
            address = address + " - " + item.address.city;
          }
          if (item.address.state) {
            address = address + " - " + item.address.state.initials || "";
          }
          if (item.address.city) {
            address = address + " CEP: " + item.address.postal_code;
          }
        }

        this.data.push([
          index + 1,
          item.name || "",
          item.email || "",
          item.phone || "",
          this.formatarData(item.created_at),
          this.formatarData(item.updated_at),
          item.signedcontract_at
            ? this.formatarData(item.signedcontract_at)
            : this.formatarData(item.updated_at),
          address,
          item.ID_Document || "",
          item.cpf || "",
          item.customer_id || "",
          this.formatarData(item.date_of_birth),
          item.gender || "",
          item.marital_status || "",
          item.marital_type || "",
          item.status || "",
          item.profissão || "",
          item.referral_balance || 0,
          item.referral_rewards || 0,
          item.payment_type === "boleto"
            ? "boleto"
            : item.payment_type === "pix"
              ? ""
              : "cartão de crédito",
          item.card_default ? "Sim" : "Não",
        ]);
        // console.log('data: ', this.data)
      });
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();

      const file = "users_" + this.formatFileName(new Date());
      // XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.utils.book_append_sheet(wb, ws, file);
      /* generate file and send to client */
      XLSX.writeFile(wb, file + ".xlsx");
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    formatarData: function (value) {
      if (!value) return "-";
      let timestamp = value; // firebase data

      let myDate = new Date(); // date object
      if (timestamp.valueOf().seconds) {
        // console.log('seconds: ', timestamp.valueOf().seconds)
        // myDate = timestamp.toDate()
        myDate = new Date(timestamp.valueOf().seconds * 1000);
      } else if (timestamp.valueOf()._seconds) {
        myDate = new Date(timestamp._seconds * 1000); // date object
      } else {
        return "-";
      }
      return moment(myDate.toISOString()).format("DD/MM/YYYY");
    },
    formatWhatsappPhone(phone) {
      let newphone = phone.replace(/\D/g, "");
      if (newphone.substring(0, 2) !== "55") {
        newphone = "55" + newphone;
      }
      return newphone;
    },
  },
};
</script>
